import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { RouteComponentProps, useLocation, withRouter } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';

import RouteChangeTracker from '@app/components/Analytics/RouteChangeTracker';
import CookiesBanner from '@app/components/UI/Banner/CookiesBanner';
import Footer from '@app/components/UI/Footer/Footer';
import Header from '@app/components/UI/Header/Header';
import { BaseHostOptions } from '@app/objects/BaseHostOptions';
import '@app/scss/style.scss';

type PageProps = RouteComponentProps<{}> & { debug: any };

const Layout: React.FC<PageProps> = (props) => {
	const location = useLocation();
	const [showSearchBar, setShowSearchBar] = React.useState(false);
	const hostOptions: BaseHostOptions = useSelector((state: any) => state?.hostOptions?.item, shallowEqual);

	React.useEffect(() => {
		const ignorePaths: RegExp[] =  [
			/^\/$/i,
			/^\/login\/?$/i
		];

		for (const path of ignorePaths) {
			if (path.test(location.pathname)) {
				setShowSearchBar(false);
				return;
			}
		}

		setShowSearchBar(true);
	}, [location]);

	return (
		<RouteChangeTracker ga_measurement_id={hostOptions?.measurementToken || ''}>
			<div className="app-container">
				<Header showSearchBar={showSearchBar} menuItems={[]}/>
				<div className="content">{props.children}</div>
				<Footer/>
			</div>
			<CookiesBanner />
		</RouteChangeTracker>
	);
};

export default withRouter(Layout) as any;
